import { CSSProperties } from 'react';
import { Footer2022, Intro2022 } from '../components';
import { use2022Page } from '../shared';

const categories = [
  { title: '藝術與文化', image: '/2022/images/ArtandCulture.gif' },
  { title: '教育技術', image: '/2022/images/EducationTechnology.gif' },
  { title: '樂齡科技', image: '/2022/images/GeronTech.gif' },
  { title: '健康科技', image: '/2022/images/HealthTech.gif' },
  { title: '行銷科技 (智慧零售 / 電子商務)', image: '/2022/images/MarketingTechnology.gif' },
  { title: '元宇宙', image: '/2022/images/Metaverse1.gif' },
  { title: '房地產科技', image: '/2022/images/PropertyTech.gif' },
  { title: '中小型企業（旅遊 / 人力資源 / 行政）', image: '/2022/images/SmallAndMediumBusiness.gif' },
  { title: '智能建設 / 環境科技 / 綠色科技', image: '/2022/images/SmartBuildingEnvironment.gif' },
  { title: '智慧政府', image: '/2022/images/SmartGovernment1.gif' },
  { title: '智慧出行', image: '/2022/images/SmartMobility1.gif' },
  { title: '智慧勞動管理', image: '/2022/images/SmartWorkforceManagement.gif' },
  { title: '智慧衣服 / 物聯網 / 機械人技術', image: '/2022/images/Wearable.gif' },
];

const benefits = [
  '得獎者名單將刊登於「2022智慧生活夥伴大獎」之網站',
  '大獎具認受性，得獎者將被譽為業界精英，能力與成就為大眾認可',
  '得獎者可授權於自己的網站和宣傳材料上展示得獎標誌',
  '廣泛的跨平台媒體報導有助公司宣傳',
  '有助得獎者於多方面取得正面宣傳與效益，包括品牌關注度、銷售及員工士氣等',
  '由主要傳媒合作夥伴及作為行業翹楚的贊助者鼎力支持',
];

const swiperVars = {
  '--swiper-navigation-color': '#fff',
  '--swiper-pagination-color': '#fff',
} as CSSProperties;

const Awards2022Zh = () => {
  use2022Page({ cate: 'awards', lang: 'zh', title: '2022智慧生活夥伴大獎 - 獎項類別' });
  return (
    <div className="slpa2022-root">
      <Intro2022 lang="zh" />
      <section id="LeadIn"><div className="wave_bg"><img src="/2022/images/wave_bg.png" alt="" /></div></section>
      <section id="AwardCategory">
        <div className="AwardCategory_info">
          <div className="AwardCategory_Title">得獎類別</div>
          <div className="AwardCategory_TitleLine"><div className="AwardCategory_TitleLineDot"><img src="/2022/images/linedot.png" alt="" /></div></div>
          <div className="AwardCategory_BubbleTable">
            <div style={swiperVars} className="swiper mySwiper2">
              <div thumbs-slider="" className="swiper mySwiper">
                <div className="swiper-wrapper">
                  {categories.map((item) => (
                    <div className="swiper-slide" key={`title-${item.image}`}>
                      <div className="swiper-slide-title">{item.title}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="swiper-wrapper">
                {categories.map((item) => (
                  <div className="swiper-slide" key={`image-${item.image}`}>
                    <div className="swiper-slide-image"><img src={item.image} alt="" /></div>
                  </div>
                ))}
              </div>
              <div className="swiper-button-next" aria-label="next"><svg className="swiper-nav-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 4L16 12L8 20"></path></svg></div>
              <div className="swiper-button-prev" aria-label="previous"><svg className="swiper-nav-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M16 4L8 12L16 20"></path></svg></div>
            </div>
          </div>
        </div>
      </section>
      <section id="AwardBenifit">
        <div className="AwardBenifit_info">
          <div className="AwardBenifit_Title">得獎者的裨益</div>
          <div className="AwardBenifit_TitleLine"><div className="AwardBenifit_TitleLineDot"><img src="/2022/images/linedot.png" alt="" /></div></div>
          <div className="AwardBenifit_Table">
            {benefits.map((text) => (
              <div className="AwardBenifit_Benifit" key={text}><p>{text}</p></div>
            ))}
          </div>
        </div>
      </section>
      <Footer2022 lang="zh" />
    </div>
  );
};

export default Awards2022Zh;

